import { Box, Flex, Image, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Button } from "@chakra-ui/react";
import { GiConfirmed } from "react-icons/gi";
import { FaCaretDown, FaRegClock } from "react-icons/fa";
import { MdHourglassTop, MdOutlineDangerous } from "react-icons/md";
import { CgDanger } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { MEETING_REQUEST_STATUS } from "../../Constants/data";
import { Images } from "../../Assets/images";
import Loader from "../../Components/Loader/Loader";
import useMeetingListState from "./useMeetingListState";
import MeetingListModals from "./MeetingListModals";
import MeetingCard from "./MeetingCard";
import ProfileDrawer from "./ProfileDrawer";

// Claude: split into useMeetingListState.ts + MeetingCard.tsx + MeetingListModals.tsx + ProfileDrawer.tsx 23-03-2026

// Module-level constant — contains JSX icons so must stay in a .tsx file
const meetsStatusArray = [
  { label: "All",              bg: "#E9FAF7",      status: MEETING_REQUEST_STATUS.TOTAL,              color: "#03A790",  icon: <GiConfirmed /> },
  { label: "Confirmed",        bg: "#E9FAF7",      status: MEETING_REQUEST_STATUS.CONFIRM,            color: "#03A790",  icon: <GiConfirmed /> },
  { label: "Request Received", bg: "orange.100",   status: MEETING_REQUEST_STATUS.REQUEST_RECEIVED,   color: "orange.600", icon: <FaRegClock /> },
  { label: "Response Awaited", bg: "orange.100",   status: MEETING_REQUEST_STATUS.RESPONSE_AWAITED,   color: "orange.600", icon: <FaRegClock /> },
  { label: "Hold",             bg: "yellow.100",   status: MEETING_REQUEST_STATUS.PUT_ON_HOLD,        color: "yellow.600", icon: <MdHourglassTop /> },
  { label: "Expired",          bg: "red.100",      status: MEETING_REQUEST_STATUS.EXPIRED,            color: "red.600",  icon: <CgDanger /> },
  { label: "Cancelled",        bg: "red.100",      status: MEETING_REQUEST_STATUS.CANCELLED,          color: "red.600",  icon: <MdOutlineDangerous /> },
  { label: "Closed",           bg: "red.100",      status: MEETING_REQUEST_STATUS.CLOSED,             color: "red.600",  icon: <IoMdClose /> },
  { label: "Incomplete",       bg: "purple.100",   status: MEETING_REQUEST_STATUS.INCOMPLETE,         color: "purple.600", icon: <MdOutlineDangerous /> },
];

type Props = {};

const MeetingList = (props: Props) => {
  const {
    loading, user,
    isModalOpen, handleModalClose, handleModalOpen,
    isCalendarModalOpen, handleCalendarModalClose, handleCalendarModalOpen,
    date, setDate, time, setTime,
    selectedMeet, setSelectedMeet, type, setType,
    responder, setResponder,
    success, error,
    meetings, userPlan, meetingCounts,
    userData, userMobileNumber, userTimezone, todayDate,
    isRedirected, activeId,
    itemRef, meetingContainerRef,
    activeMeetingItem, setActiveMeetingItem,
    changeConfirmationModal, selectedChangeMeeting, setSelectedChangeMeeting,
    handleOpenChangeConfirmationModal, handleCloseChangeConfirmationModal,
    isDrawerOpen, onDrawerClose,
    selectedProfile, selectedMeetingItem,
    drawerNotes, drawerSellerEvents,
    meetConfirm, handleOpenMeetConfirmModal, handleCloseMeetConfirmModal,
    meetTimeConfirm, handleOpenMeetTimeConfirmModal, handleCloseMeetTimeConfirmModal,
    feedbackModal, selectedFeedbackMeeting,
    handleCloseFeedbackModal,
    releModal, relevanceData, buyerRelevanceData,
    handleCloseRelevanceModal,
    status, setStatus,
    getData, handleUpdate, handleUpdateMeetingUrl,
    allowCall,
    buttonTypeAcceptClick,
    changeMeetingRequestStatus,
    getRelevanceStatusForMeeting, handleRelevanceClick, reloadRelevanceData,
    isFeedbackVisible, handleFeedbackClick, handleFeedbackYes, handleFeedbackNo,
    openProfileDrawer,
    handleSubmitEditOrNew,
  } = useMeetingListState();

  return (
    <>
      {/* Claude: Use warm background matching Feeds page style 09-02-2026 */}
      {/* Claude: app-style fixed layout — filter static, cards scroll 27-03-2026 */}
      <Box
        width={"100%"}
        display={"flex"}
        flexDirection={"column"}
        px={6}
        pt={6}
        bg={"linear-gradient(180deg, #FFEBDC 0%, #FFF5EE 100%)"}
        h={"calc(100dvh - 65px)"}
        overflow={"hidden"}
      >
        <MeetingListModals
          user={user}
          meetings={meetings}
          meetsStatusArray={meetsStatusArray}
          changeConfirmationModal={changeConfirmationModal}
          handleCloseChangeConfirmationModal={handleCloseChangeConfirmationModal}
          selectedChangeMeeting={selectedChangeMeeting}
          setSelectedMeet={setSelectedMeet}
          handleCalendarModalOpen={handleCalendarModalOpen}
          setType={setType}
          error={error}
          feedbackModal={feedbackModal}
          handleCloseFeedbackModal={handleCloseFeedbackModal}
          selectedFeedbackMeeting={selectedFeedbackMeeting}
          handleFeedbackYes={handleFeedbackYes}
          handleFeedbackNo={handleFeedbackNo}
          releModal={releModal}
          handleCloseRelevanceModal={handleCloseRelevanceModal}
          relevanceData={relevanceData}
          buyerRelevanceData={buyerRelevanceData}
          reloadRelevanceData={reloadRelevanceData}
          meetTimeConfirm={meetTimeConfirm}
          handleCloseMeetTimeConfirmModal={handleCloseMeetTimeConfirmModal}
          activeMeetingItem={activeMeetingItem}
          handleUpdate={handleUpdate}
          setActiveMeetingItem={setActiveMeetingItem}
          selectedMeet={selectedMeet}
          changeMeetingRequestStatus={changeMeetingRequestStatus}
          meetConfirm={meetConfirm}
          handleCloseMeetConfirmModal={handleCloseMeetConfirmModal}
          activeId={activeId}
          isModalOpen={isModalOpen}
          handleModalClose={handleModalClose}
          status={status}
          setStatus={setStatus}
          meetingCounts={meetingCounts}
          isCalendarModalOpen={isCalendarModalOpen}
          handleCalendarModalClose={handleCalendarModalClose}
          date={date}
          setDate={setDate}
          time={time}
          setTime={setTime}
          handleSubmitEditOrNew={handleSubmitEditOrNew}
        />

        {/* Claude: Dark header section 09-02-2026 — AFTR logo on right 23-02-2026 */}
        <Flex
          alignItems={"center"} justifyContent={"space-between"}
          bg={"#0E122F"} color={"white"}
          mx={-6} mt={-6} px={6} py={5} mb={2}
          width={"calc(100% + 48px)"}
        >
          <Text fontSize={"xl"} fontWeight={700}>Meetings</Text>
          {/* Claude: role label below logo in header 25-02-2026 */}
          <VStack spacing={0} alignItems="center" justifyContent="center">
            <Image src={Images.AftrLogo} h="32px" objectFit="contain" />
            <Text fontSize="11px" fontWeight={300} color="whiteAlpha.600" letterSpacing="wide">
              {user.role === "Seller" ? "seller (beta)" : "buyer (beta)"}
            </Text>
          </VStack>
        </Flex>

        {/* Filter row — static, never scrolls */}
        <Flex justifyContent={"flex-end"} flexShrink={0} py={2}>
          <Button
            shadow={"md"} border={"1px solid"} borderColor={"gray.200"}
            p={0} py={2} px={3} fontSize={"xs"}
            bg={meetsStatusArray.find((meet) => meet.status == status)?.bg}
            color={meetsStatusArray.find((meet) => meet.status == status)?.color}
            display={"flex"} gap={2}
            onClick={handleModalOpen}
          >
            {meetsStatusArray.find((meet) => meet.status == status)?.label} ({meetings.length})
            <FaCaretDown />
          </Button>
        </Flex>

        {/* Meeting cards list — only this scrolls */}
        <Flex
          ref={meetingContainerRef as React.LegacyRef<HTMLDivElement>}
          direction={"column"}
          gap={5}
          flex={1}
          overflowY={"auto"}
          pb={4}
        >
          {meetings?.length != 0 ? (
            meetings?.map((item: any, key: number) => {
              console.log("Item : Meeting is:", item);
              console.log("MeetingUTC is:", item.meetingUTC);
              return (
                <MeetingCard
                  key={item._id || key}
                  item={item}
                  isRedirected={isRedirected}
                  itemRef={itemRef as React.RefObject<HTMLDivElement>}
                  status={status}
                  meetsStatusArray={meetsStatusArray}
                  todayDate={todayDate}
                  user={user}
                  userMobileNumber={userMobileNumber}
                  userTimezone={userTimezone}
                  userPlan={userPlan}
                  meetings={meetings}
                  allowCall={allowCall}
                  handleUpdate={handleUpdate}
                  handleOpenMeetConfirmModal={handleOpenMeetConfirmModal}
                  buttonTypeAcceptClick={buttonTypeAcceptClick}
                  setSelectedMeet={setSelectedMeet}
                  setResponder={setResponder}
                  handleCalendarModalOpen={handleCalendarModalOpen}
                  setType={setType}
                  setSelectedChangeMeeting={setSelectedChangeMeeting}
                  handleOpenChangeConfirmationModal={handleOpenChangeConfirmationModal}
                  openProfileDrawer={openProfileDrawer}
                  getRelevanceStatusForMeeting={getRelevanceStatusForMeeting}
                  handleRelevanceClick={handleRelevanceClick}
                  isFeedbackVisible={isFeedbackVisible}
                  handleFeedbackClick={handleFeedbackClick}
                  error={error}
                  handleUpdateMeetingUrl={handleUpdateMeetingUrl}
                />
              );
            })
          ) : (
            <Flex justifyContent={"center"} alignItems={"center"}>
              {loading && <Loader />}
            </Flex>
          )}
        </Flex>
      </Box>

      {/* Claude: Profile drawer for viewing other party's details from meeting cards 09-02-2026 */}
      <ProfileDrawer
        isDrawerOpen={isDrawerOpen}
        onDrawerClose={onDrawerClose}
        selectedProfile={selectedProfile}
        drawerNotes={drawerNotes}
        drawerSellerEvents={drawerSellerEvents}
      />
    </>
  );
};

export default MeetingList;
